import "core-js/modules/es6.number.constructor";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { serveEvaluateBigVoList, serveEvaluateSmallVo, serveEvaluateTypeVoList, serveSatisfactionVoList } from "@/api/serveCenter/serveCenter";
import evaluateDialog from "@/views/serveCenter/evaluateDialog";
export default {
  name: "serveEvaluate",
  components: {
    evaluateDialog: evaluateDialog
  },
  props: [],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      serveId: "",
      loading: false,
      commentLoading: false,
      curTabVal: 0,
      paramSearch: {
        current: 1,
        ix: 0,
        size: 10,
        total: 0,
        serve_id: ""
      },
      commentList: [],
      satisfactionVoList: [],
      evaluateSmallVo: {}
    };
  },
  computed: {
    rnkCntTotal: function rnkCntTotal() {
      var total = 0;
      this.satisfactionVoList.forEach(function (i) {
        total += Number(i.rnkCnt);
      });
      return total;
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.serveId = this.$route.query.id;
    this.paramSearch.serve_id = this.serveId;
    this.getServeEvaluateBigVoList();
    this.getServeEvaluateSmallVo(); // this.getServeEvaluateTypeVoList();

    this.getServeSatisfactionVoList();
  },
  methods: {
    openAttach: function openAttach(url) {
      window.open(url);
    },
    saveSuccess: function saveSuccess() {
      this.getServeEvaluateBigVoList();
      this.getServeEvaluateSmallVo();
      this.getServeSatisfactionVoList();
    },
    swtichTab: function swtichTab(val) {
      this.curTabVal = val;
      this.paramSearch.ix = val;
      this.paramSearch.current = 1;
      this.getServeEvaluateBigVoList();
    },
    goEvaluateShow: function goEvaluateShow() {
      this.$refs.evaluateDialog.dialogShow(this.serveId);
    },
    getServeSatisfactionVoList: function getServeSatisfactionVoList() {
      var _this = this;

      serveSatisfactionVoList({
        serve_id: this.serveId
      }).then(function (_ref) {
        var data = _ref.data;

        if (data.code == 0) {
          _this.satisfactionVoList = data.data || [];
        }
      }).catch(function () {});
    },
    // 获取评价查询列表
    getServeEvaluateTypeVoList: function getServeEvaluateTypeVoList() {
      serveEvaluateTypeVoList({
        score: "2"
      }).then(function (_ref2) {
        var data = _ref2.data;

        if (data.code == 0) {}
      }).catch(function () {});
    },
    // 获取评价查询列表
    getServeEvaluateSmallVo: function getServeEvaluateSmallVo() {
      var _this2 = this;

      serveEvaluateSmallVo(this.paramSearch).then(function (_ref3) {
        var data = _ref3.data;

        if (data.code == 0) {
          _this2.evaluateSmallVo = data.data || {};
        }
      }).catch(function () {});
    },
    // 条数
    changeSize: function changeSize(value) {
      this.paramSearch.size = value;
      this.paramSearch.current = 1;
      this.getServeEvaluateBigVoList();
    },
    // 翻页
    changePage: function changePage(value) {
      this.paramSearch.current = value;
      this.getServeEvaluateBigVoList();
    },
    // 获取评价查询列表
    getServeEvaluateBigVoList: function getServeEvaluateBigVoList() {
      var _this3 = this;

      this.commentLoading = true;
      serveEvaluateBigVoList(this.paramSearch).then(function (_ref4) {
        var data = _ref4.data;
        _this3.commentLoading = false;

        if (data.code == 0) {
          _this3.commentList = data.data.records || [];
          _this3.paramSearch.total = data.data.total;
        }
      }).catch(function () {
        _this3.commentLoading = false;
      });
    }
  },
  destroyed: function destroyed() {},
  watch: {},
  filters: {}
};